var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconHelp = function SvgIconHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-.39 10.789c.598 0 1.035.413 1.035.95v.138c0 .537-.437.95-1.035.95-.597 0-1.035-.413-1.035-.95v-.138c0-.537.438-.95 1.035-.95zm.33-7.797c2.098 0 3.522 1.075 3.522 2.797v.027c0 1.736-1.364 2.52-3.028 2.783l-.06.633c-.06.303-.3.551-.644.551h-.09a.632.632 0 0 1-.645-.55l-.15-1.185c-.06-.372.18-.648.585-.69 1.409-.123 2.188-.619 2.188-1.487v-.027c0-.772-.644-1.309-1.723-1.309-.795 0-1.44.262-2.039.758a.951.951 0 0 1-.555.193c-.464 0-.839-.345-.839-.758a.75.75 0 0 1 .3-.592c.794-.69 1.799-1.144 3.178-1.144z",
    fill: "#525254",
    fillRule: "evenodd"
  })));
};

export default SvgIconHelp;